const compareObjects = (obj1, obj2) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  // objs are the same
  return true;
};

const compareArrays = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every((obj, index) => {
    const otherObj = arr2[index];
    const keys1 = Object.keys(obj).filter((key) => key !== 'id');
    const keys2 = Object.keys(otherObj).filter((key) => key !== 'id');

    if (keys1.length !== keys2.length) {
      return false;
    }

    return keys1.every((key) => obj[key] === otherObj[key]);
  });
};

export {
  // eslint-disable-next-line import/prefer-default-export
  compareArrays,
  compareObjects,
};
